.sidebar {
  width: 250px;
  padding: 20px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvU2lkZWJhciIsInNvdXJjZXMiOlsiU2lkZWJhci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFFQTtFQUVBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5zaWRlYmFyIHtcbiAgd2lkdGg6IDI1MHB4O1xuICBwYWRkaW5nOiAyMHB4O1xuICBcbiAgZmxleC1zaHJpbms6IDA7XG5cbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgZ2FwOiAyMHB4O1xufSJdfQ== */